// extracted by mini-css-extract-plugin
module.exports = {"ecCarouselItems":"Default_ecCarouselItems__1AS5T","ecCarouselItem":"Default_ecCarouselItem__aLSaM","showScale":"Default_showScale__sfglL"};